<script>
import Glide from "@glidejs/glide";
export default {
  data() {
    return {
      glide: null
    };
  },
  mounted() {
    this.glide = new Glide(this.$el, {
      perView: 4,
      gap: 24,
      breakpoints: {
        500: {
          perView: 1
        },
        1100: {
          perView: 2
        }
      }
    }).mount();
  },
  methods: {
    next() {
      this.glide.go(">");
    },
    prev() {
      this.glide.go("<");
    }
  }
};
</script>

<template>
  <div class="glide">
    <div class="glide__track" data-glide-el="track">
      <div class="glide__slides pb-6">
        <slot></slot>
      </div>
    </div>
    <button
      class="bg-white rounded-full shadow-lg hover:shadow-xl w-10 h-10 outline-none absolute flex items-center justify-center text-grey hover:text-purple z-10"
      style="left: -30px; top: 40%;"
      @click="prev"
      title="Tip: use your keyboard left and right buttons to navigate."
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 501.5 501.5"
        class="w-6 h-6 fill-current rotate-180"
      >
        <g>
          <path
            d="M199.33 410.622l-55.77-55.508L247.425 250.75 143.56 146.384l55.77-55.507L358.44 250.75z"
          />
        </g>
      </svg>
    </button>
    <button
      class="bg-white rounded-full shadow-lg hover:shadow-xl w-10 h-10 outline-none absolute flex items-center justify-center text-grey hover:text-purple z-10"
      style="right: 30px; top: 40%;"
      @click="next"
      title="Tip: use your keyboard left and right buttons to navigate."
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 501.5 501.5"
        class="w-6 h-6 fill-current"
      >
        <g>
          <path
            d="M199.33 410.622l-55.77-55.508L247.425 250.75 143.56 146.384l55.77-55.507L358.44 250.75z"
          />
        </g>
      </svg>
    </button>
    <div class="gradient-white-right w-24 md:w-32 pin-t pin-b pin-r absolute"></div>
  </div>
</template>
